export default "__VITE_ASSET__BNhrnSB5__"